import type { VoucherPerformanceOrder } from '@/marketing/models/voucher';

export type VoucherOrderDisplayStatus = 'paid' | VoucherPerformanceOrder['status'];

export interface VoucherOrderStatusInput {
  status: VoucherPerformanceOrder['status'];
  settled: boolean;
  paid?: boolean;
}

/**
 * Only actual payout completion reads as Paid. Inclusion in a payout row is not payment.
 * Cancellation and refund remain visible even after a payout.
 */
export function resolveVoucherOrderDisplayStatus({ status, paid }: VoucherOrderStatusInput): VoucherOrderDisplayStatus {
  if (status === 'refunded' || status === 'cancelled') {
    return status;
  }
  return paid === true ? 'paid' : status;
}

export const VOUCHER_ORDER_STATUS_LABELS: Record<VoucherOrderDisplayStatus, string> = {
  paid: 'Paid',
  confirmed: 'Confirmed',
  pending: 'Pending',
  refunded: 'Refunded',
  cancelled: 'Cancelled',
};
